import axios from '@/plugins/axios';
import { logApiError } from '@/services/api.js';

export const getPublicLlms = async () => {
  try {
    const response = await axios.get('/api/llms/public');
    return response.data;
  } catch (error) {
    logApiError(error, 'GET', '/api/llms/public');
    throw error;
  }
};

export const estimateModelRun = async ({ dataset_id, version, llm_ids }) => {
  try {
    const response = await axios.post('/api/eval-runs/estimate', {
      dataset_id,
      version,
      llm_ids,
    });
    return response.data;
  } catch (error) {
    logApiError(error, 'POST', '/api/eval-runs/estimate');
    throw error;
  }
};

export const createModelRun = async ({ dataset_id, version, llm_ids }) => {
  try {
    const response = await axios.post('/api/eval-runs/model-run', {
      dataset_id,
      version,
      llm_ids,
    });
    return response.data;
  } catch (error) {
    logApiError(error, 'POST', '/api/eval-runs/model-run');
    throw error;
  }
};
